(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rail-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rail-collection')) {
    customElements.define(
      'rail-collection',
      class RailCollection extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.rail__item'));
          this.titleEl = this.querySelector('.rail__title');
          this.scroller = this.querySelector('.rail__scroller');
          if (!this.items.length) return;

          const start = Math.min(parseInt(this.dataset.start || '0', 10), this.items.length - 1);
          this.activate(this.items[start], false);

          const canHover = window.matchMedia('(hover: hover)').matches;

          this.items.forEach((item) => {
            const link = item.querySelector('.rail__link');
            if (canHover) {
              item.addEventListener('mouseenter', () => this.activate(item, false));
            }
            item.addEventListener('focusin', () => this.activate(item, false));
            if (link) {
              link.addEventListener('click', (event) => {
                if (!item.classList.contains('is-active')) {
                  event.preventDefault();
                  this.activate(item, true);
                }
              });
            }
          });
        }

        activate(item, scroll) {
          if (!item) return;
          this.items.forEach((el) => el.classList.toggle('is-active', el === item));
          if (this.titleEl) this.titleEl.textContent = item.dataset.title || '';
          if (scroll && this.scroller) {
            window.setTimeout(() => {
              const s = this.scroller;
              const left = item.offsetLeft + item.offsetWidth / 2 - s.clientWidth / 2;
              s.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
            }, 350);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
